export default "https://cdn-static.gokick.com/assets/c66ec253f0896645bf734992981ccce4219a90e3/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";